export default `p.z-=20;
    float s=3., l=0.;
    p=abs(p);
    for(int j=0;j++<10;)
      p=-sign(p)*(abs(abs(abs(p)-2.)-1.)-1.),
      p*=l=-1./max(.19,dot(p,p)),
      p-=.24, s*=l;
    return (length(p)/s);
  }`